export const RedirectionUrl = {
  termsAndConditionUrl: 'https://cyphlens.com/legal/terms-and-conditions.html',
  privacyPolicyUrl: 'https://cyphlens.com/legal/privacy-policy.html',
};
